import React from 'react'
import PopupPlan from '~/components/PopupPlan'
import _ from 'lodash'
import './style.scss'

class SelectPlan extends React.Component {
  getVal(key){
    return _.get(this.props.metadataMap, key)
  }
  render() {
    let plans = this.props.plans
    return (
      <div className="select-plans-container">
        <div className="plans">
          { plans.map( (p, i) => {
          return (
              <PopupPlan
                plan={p}
                key={i}
                selected={this.props.selected === i}
                onClick={ _ => this.props.selectPlan(i) } />
              )
          }) }
          
        </div>
        <div className="legal-texts" dangerouslySetInnerHTML={{__html: this.getVal('planLegalText')}} />
      </div>
    )
  }
}

export default SelectPlan;